import { callFetch } from './serviceHelpers';

export const getTree = () => callFetch(process.env.REACT_APP_CATALOG_SCHEMA_URL, 'GET', 'v2/tree');
